import sha256 from 'crypto-js/sha256';

const encode = encodeURIComponent;

const Auth = requests => ({
  current: () => requests.get('/user/self'),
  login: (userCode, password) =>
    requests.get(`/login?userCode=${encode(userCode)}&password=${encode(sha256(password).toString())}`),
});

export default Auth;



// WEBPACK FOOTER //
// ./src/agent/auth.js